import type { shell as en } from "../en/shell";
import type { Messages } from "../types";

export const shell: Messages<typeof en> = {
  nav: {
    groupWork: "العمل",
    groupGrow: "النمو",
    groupAi: "الذكاء الاصطناعي",
    home: "الرئيسية",
    inbox: "صندوق الوارد",
    approvals: "الموافقات",
    content: "المحتوى",
    calendar: "التقويم",
    posts: "المنشورات",
    compose: "إنشاء منشور",
    automation: "القواعد",
    rules: "القواعد",
    runs: "سجل الأتمتة",
    agents: "الوكلاء الأذكياء",
    analytics: "التحليلات",
    dashboards: "لوحات المتابعة",
    studio: "استوديو الذكاء",
    assistant: "المساعد",
    contacts: "جهات الاتصال",
    people: "الأشخاص",
    jobs: "المهام",
    settings: "الإعدادات",
    more: "المزيد",
    admin: "الإدارة",
  },
  accounts: {
    all: "كل الحسابات",
    allHint: "كل القنوات المربوطة",
    switch: "تبديل الحساب",
    connectMore: "ربط قناة",
    followers: "{{n}} متابع",
    reconnect: "إعادة ربط ‎@{{user}}",
  },
  topbar: {
    search: "ابحث أو انتقل إلى…",
    approvalsWaiting_zero: "{{count}} بانتظار الموافقة",
    approvalsWaiting_one: "{{count}} بانتظار الموافقة",
    approvalsWaiting_two: "{{count}} بانتظار الموافقة",
    approvalsWaiting_few: "{{count}} بانتظار الموافقة",
    approvalsWaiting_many: "{{count}} بانتظار الموافقة",
    approvalsWaiting_other: "{{count}} بانتظار الموافقة",
    live: "مباشر",
    liveConnecting: "جارٍ الاتصال…",
    liveReconnecting: "إعادة الاتصال…",
    liveOffline: "غير متصل",
    liveIdle: "غير متصل",
    liveHint: "تحديثات مباشرة: تظهر التعليقات والرسائل الجديدة دون تحديث الصفحة.",
    theme: "المظهر",
    themeSystem: "حسب النظام",
    themeLight: "فاتح",
    themeDark: "داكن",
    language: "اللغة",
    switchLang: "English",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    shortcuts: "اختصارات لوحة المفاتيح",
    signOut: "تسجيل الخروج",
    signedInAs: "مسجّل باسم",
    mockMode: "بيانات تجريبية",
    mockHint: "أنت تستكشف ببيانات تجريبية. لا يُرسل شيء إلى إنستغرام.",
  },
  notifications: {
    title: "الإشعارات",
    empty: "لا جديد",
    emptyHint: "ستظهر هنا الموافقات وتنبيهات الأزمات والمنشورات المتعثرة.",
    markAllRead: "تمييز الكل كمقروء",
    newComment: "تعليق جديد من ‎@{{user}}",
  },
  palette: {
    placeholder: "اكتب أمراً أو ابحث…",
    empty: "لا نتائج",
    navigate: "انتقل إلى",
    actions: "إجراءات",
    recent: "الأخيرة",
    preferences: "التفضيلات",
    newPost: "إنشاء منشور",
    newRule: "إنشاء قاعدة أتمتة",
    askAssistant: "اسأل المساعد",
    voiceMode: "تحدّث مع المساعد صوتياً",
    toggleTheme: "تبديل الوضع الداكن",
    toggleLang: "Switch language to English",
    openShortcuts: "عرض اختصارات لوحة المفاتيح",
    signOut: "تسجيل الخروج",
    inboxNegative: "الوارد: التعليقات السلبية",
    inboxUnassigned: "الوارد: غير المُسندة",
  },
  shortcuts: {
    title: "اختصارات لوحة المفاتيح",
    global: "في كل مكان",
    inbox: "صندوق الوارد",
    approvals: "الموافقات",
    palette: "لوحة الأوامر",
    help: "عرض هذه القائمة",
    goHome: "الانتقال للرئيسية",
    goInbox: "الانتقال للوارد",
    goApprovals: "الانتقال للموافقات",
    goCalendar: "الانتقال للتقويم",
    goAutomation: "الانتقال للأتمتة",
    goAnalytics: "الانتقال للتحليلات",
    next: "العنصر التالي",
    prev: "العنصر السابق",
    done: "تم",
    reply: "رد",
    hide: "إخفاء / إظهار",
    assign: "إسناد لي",
    search: "بحث",
    select: "تحديد العنصر",
    approve: "موافقة",
    reject: "رفض",
    editDraft: "تعديل المسودة",
    then: "ثم",
  },
  crisis: {
    title: "ارتفاع في التعليقات السلبية",
    body_zero: "{{count}} تعليق سلبي خلال آخر 24 ساعة، أعلى من المعتاد بنسبة {{pct}}.",
    body_one: "تعليق سلبي واحد خلال آخر 24 ساعة، أعلى من المعتاد بنسبة {{pct}}.",
    body_two: "تعليقان سلبيان خلال آخر 24 ساعة، أعلى من المعتاد بنسبة {{pct}}.",
    body_few: "{{count}} تعليقات سلبية خلال آخر 24 ساعة، أعلى من المعتاد بنسبة {{pct}}.",
    body_many: "{{count}} تعليقًا سلبيًا خلال آخر 24 ساعة، أعلى من المعتاد بنسبة {{pct}}.",
    body_other: "{{count}} تعليق سلبي خلال آخر 24 ساعة، أعلى من المعتاد بنسبة {{pct}}.",
    action: "راجِع الآن",
  },
  batch: {
    running: "جارٍ التطبيق على {{done}} من {{total}}…",
    done: "تم: {{done}} من {{total}}",
    failed: "{{failed}} فشل",
    opFailed: "لم تكتمل العملية. حاول مجددًا.",
    opCancelled: "أُلغيت",
    cancel: "إلغاء",
  },
  admin: {
    title: "إدارة المنصة",
    description: "أدوات فريق ملفك. هذا القسم قيد البناء، وواجهته البرمجية غير جاهزة بعد.",
    badge: "للفريق فقط",
    soon: "قريباً",
    sections: {
      orgs: "المؤسسات والباقات",
      users: "المستخدمون والجلسات",
      channels: "صحة القنوات والـ Webhooks",
      ai: "استهلاك الذكاء الاصطناعي وتكلفته",
      flags: "مفاتيح الميزات",
      audit: "سجل التدقيق",
    },
  },
};
